import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import Confetti from 'react-confetti';

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);
  const [windowDimension, setWindowDimension] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const detectSize = () => {
      setWindowDimension({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', detectSize);

    return () => {
      window.removeEventListener('resize', detectSize);
    };
  }, []);

  const handleViewOrder = () => {
    const token = sessionStorage.getItem('guestOrderToken');
    if (!token) {
      navigate(`/profile/`);
    } else {
      navigate(`/guest-profile/`);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-green-100 flex items-center justify-center relative overflow-hidden pt-[8rem]">
      {/* Continuous Party Popper Effect */}
      <Confetti
        width={windowDimension.width}
        height={windowDimension.height}
        numberOfPieces={100}
        recycle={true}
        colors={['#22c55e', '#16a34a', '#15803d', '#166534', '#14532d', '#86efac', '#FFD700', '#FF69B4']}
        gravity={0.3}
        initialVelocityX={15}
        initialVelocityY={30}
        explosionForce={0.8}
        friction={0.99}
        wind={0.01}
        confettiSource={{
          x: windowDimension.width / 2,
          y: windowDimension.height,
          w: 0,
          h: 0
        }}
      />

      <div className="bg-white p-12 rounded-2xl shadow-2xl text-center relative z-10 max-w-md w-full">
        <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
          <Check className="text-white w-12 h-12" />
        </div>

        <h1 className="text-3xl font-bold text-gray-800 mb-4 animate-pulse">
          Thank You for Your Purchase!
        </h1>

        {orderDetails && (
          <div className="text-gray-600 mb-6">
            <p>Order Number: <span className="font-semibold">{orderDetails.orderId}</span></p>
          </div>
        )}

        <p className="text-gray-500 mb-6">
          Your order has been successfully processed.
          You will receive a confirmation email shortly.
        </p>

        <button
          onClick={handleViewOrder}
          className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-all transform hover:scale-105"
        >
          View Order Details
        </button>
      </div>
    </div>
  );
};

export default OrderConfirmation;